import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { LanguageBackendType } from "./types";

export default function useLanguageValidator(
  languages = [
    LanguageBackendType.ENGLISH,
    LanguageBackendType.GERMAN,
    LanguageBackendType.ITALIAN,
    LanguageBackendType.FRENCH,
  ],
): Yup.StringSchema {
  const { getMessage } = useMessageSource();

  return Yup.string()
    .nullable()
    .test(
      "null is not acceptable",
      getMessage("Validation.message-required"),
      (val) => {
        return !(val === null || val === undefined);
      },
    )
    .oneOf(languages, getMessage("Validation.message-required"));
}
